/// <reference path="DOMAttached.js" />

class ExternalHyperLink extends DOMAttached {
	constructor(el) {
		super(el);

		this.safeObserve(this.el, 'click', this.onClick.bind(this));
	}

	onClick(ev) {
		window.open(this.el.getAttribute('href'));
		ev.preventDefault();
		ev.stopPropagation();
	}
}
